<template lang="pug">
    el-tooltip(:content='title', :disabled='!title', placement='top')
        span.resumo-tag(:class="statusClass")
            i.resumo-tag-icon(:class="statusIcon")
            | {{ $t(`mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.restricoesTag.${status}`) }}
</template>

<script>
const STATUS_CONFIG = {
    SUCESSO: {
        icon: 'el-icon-circle-check',
        classe: 'resumo-tag--sucesso'
    },
    ALERTA: {
        icon: 'el-icon-circle-close',
        classe: 'resumo-tag--alerta'
    },
    ATENCAO: {
        icon: 'el-icon-warning',
        classe: 'resumo-tag--atencao'
    },
    NAO_SE_APLICA: {
        icon: 'el-icon-remove-outline',
        classe: 'resumo-tag--nao-se-aplica'
    },
    NAO_ANALISADO: {
        icon: 'el-icon-remove-outline',
        classe: 'resumo-tag--nao-analisado'
    }
};

export default {
    name: 'ResumoTag',
    props: {
        status: {
            type: String,
            required: true,
            validator: (value) => Object.keys(STATUS_CONFIG).includes(value)
        },
        title: {
            type: String,
            default: null
        }
    },
    computed: {
        statusConfig() {
            return STATUS_CONFIG[this.status] || {};
        },
        statusIcon() {
            return this.statusConfig.icon || '';
        },
        statusClass() {
            return this.statusConfig.classe || '';
        }
    }
};
</script>

<style lang="scss" scoped>
.resumo-tag {
    display: inline-flex;
    align-items: center;
    justify-content: space-around;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
    width: 140px;
    text-align: center;

    .resumo-tag-icon {
        margin-right: 5px;
        font-size: 16px;
    }

    &--sucesso {
        background-color: #ecfcf4;
        color: #3d8c73;
        border: 1px solid #3d8c73;
    }

    &--alerta {
        background-color: #fff1f0;
        color: #df675b;
        border: 1px solid #df675b;
    }

    &--atencao {
        background-color: #f6efca;
        color: #c7b239;
        border: 1px solid #d7bc25;
    }

    &--nao-se-aplica,
    &--nao-analisado {
        background-color: #a0a0a033;
        color: #5e5e5e;
        border: 1px solid #8a8a8a;
    }
}
</style>
